import { useEffect } from "react";
import { XCircle } from "lucide-react";

export default function CancelledOverlay({ info, onDone, duration = 7000 }) {
  useEffect(() => {
    if (!info) return;
    const id = setTimeout(onDone, duration);
    return () => clearTimeout(id);
  }, [info, onDone, duration]);
  if (!info) return null;
  return (
    <div data-testid="order-cancelled-overlay" onClick={onDone} className="fixed inset-0 z-[120] bg-[#B4462F] text-white flex flex-col items-center justify-center text-center px-8 animate-fade-in">
      <XCircle className="w-24 h-24 mb-6" strokeWidth={1.5} />
      <p className="font-serif-display text-3xl font-bold leading-tight">{info.title}</p>
      <p data-testid="order-cancelled-overlay-text" className="mt-4 text-base text-white/90 max-w-sm">{info.text}</p>
      <p className="mt-10 text-xs uppercase tracking-widest text-white/60">{info.hint}</p>
    </div>
  );
}
